var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FEDA00","d":"M15.857 0H6.601C5.715 0 5 .718 5 1.603v18.796A1.6 1.6 0 0 0 6.601 22h9.256c.885 0 1.601-.718 1.601-1.601V1.603c0-.885-.716-1.603-1.6-1.603ZM11.23 20.418a1.022 1.022 0 1 1 0-2.044 1.022 1.022 0 0 1 0 2.044Zm5.029-3.502H6.2V2.704H16.26v14.212Z"}));
}

Phone.defaultProps = {"width":"22","height":"22","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
